import React, { useEffect, useState } from "react";
import { DEMO_POSTS } from "data/posts";
import { IBlogsItem, IGetBlogsResponse, PostDataType } from "data/types";
import Pagination from "components/Pagination/Pagination";
import ButtonPrimary from "components/Button/ButtonPrimary";
// import { DEMO_AUTHORS } from "data/authors";
// import { DEMO_CATEGORIES } from "data/taxonomies";
import Nav from "components/Nav/Nav";
import NavItem from "components/NavItem/NavItem";
import SocialsList from "components/SocialsList/SocialsList";
import ArchiveFilterListBox from "components/ArchiveFilterListBox/ArchiveFilterListBox";
// import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import Card11 from "components/Card11/Card11";
// import BackgroundSection from "components/BackgroundSection/BackgroundSection";
// import SectionGridCategoryBox from "components/SectionGridCategoryBox/SectionGridCategoryBox";
// import ButtonSecondary from "components/Button/ButtonSecondary";
// import SectionSliderNewAuthors from "components/SectionSliderNewAthors/SectionSliderNewAuthors";
import NcImage from "components/NcImage/NcImage";
import { GlobeAltIcon, ShareIcon } from "@heroicons/react/24/outline";
import { avatarImgs } from "contains/fakeData";
import VerifyIcon from "components/VerifyIcon";
// // import FollowButton from "components/FollowButton";
// import NcDropDown from "components/NcDropDown/NcDropDown";
// import { SOCIALS_DATA } from "components/SocialsShare/SocialsShare";
// import AccountActionDropdown from "components/AccountActionDropdown/AccountActionDropdown";
import Image from "components/Image";
import api from "utils/axios";
import Loading from "components/Button/Loading";
import PaginationCustom from "components/PaginationCustom/PaginationCustom";
import { dictionary } from "utils/dictionary";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectWebsiteTitle } from "../../redux/core/core-slice";

import LogoAAA from "../../images/LogoAAA.png";

//@ts-ignore
import { Helmet } from "react-helmet";
import { getLanguageId } from "utils/getLanguageId";

// const posts: PostDataType[] = DEMO_POSTS.filter((_, i) => i < 12);
const POST_TEMP = {
  index: 1,
  id: "9e3e3994-a3ed-47ca-a014-d4483884cfe2",
  featuredImage:
    "https://images.unsplash.com/photo-1440778303588-435521a205bc?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
  title: "Lenovo’s smarter devices stoke professional passions",
  desc: "Aenean lectus. Pellentesque eget nunc. Donec quis orci eget orci vehicula condimentum.",
  date: "May 20, 2021",
  href: "/single/this-is-single-slug",
  commentCount: 11,
  viewedCount: 2504,
  readingTime: 2,
  bookmark: { count: 3007, isBookmarked: false },
  like: { count: 3366, isLiked: true },
  authorId: 3,
  categoriesId: [3, 12],
  postType: "standard",
  author: "John Doe", // assign author name
  categories: ["Technology", "Business"], // assign categories
};

const FILTERS = [
  { name: "Most Recent" },
  { name: "Curated by Admin" },
  { name: "Most Appreciated" },
  { name: "Most Discussed" },
  { name: "Most Viewed" },
];
// const TABS = ["Articles", "Favorites", "Saved"];
const PageAuthor = () => {
  const { t } = useTranslation();
  const websiteTitle = useSelector(selectWebsiteTitle);
  const TABS = [t("articles")];
  const [tabActive, setTabActive] = useState<string>(TABS[0]);

  const currentLayoutLanguage = localStorage.getItem('currentLayoutLanguage'); 
  const [blogs, setBlogs] = useState<IBlogsItem[]>([]);
  const [totalNumberOfBlogs, setTotalNumberOfBlogs] = useState<number>(0);
  const [blogsLoading, setBlogsLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const pageSize = 10;

  const getBlogs = async (page: number) => {
    setBlogsLoading(true);
    try {
      const res: IGetBlogsResponse = await api.get(`/Post/get-all-active?language=${getLanguageId(currentLayoutLanguage)}`, {
        params: { offset: page },
      });
      if (res) {
        setTotalNumberOfBlogs(res?.data?.data?.totalDataCount);
        setBlogs(res?.data?.data?.data);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setBlogsLoading(false);
      window.scrollTo({ top: 0 , behavior: 'smooth'});
    }
  };

  useEffect(() => {
    getBlogs(currentPage);
  }, [currentPage]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  // const handlePageChange = (page: number) => {
  //   if (page !== currentPage) {
  //     getBlogs(page);
  //   }
  // };

  // const handleClickTab = (item: string) => {
  //   if (item === tabActive) {
  //     return;
  //   }
  //   setTabActive(item);
  // };

  return (
    <div className={`nc-PageAuthor bg-image`}>
      {/* HEADER */}
      <Helmet>
        {/* <title>{"Aysel Aydin Alizada"}</title> */}
        <meta name="description" content={websiteTitle?.data?.bioContent} />
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content={"Aysel Aydin Alizada"} />
        <meta property="og:description" content={websiteTitle?.data?.bioContent} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dev.optima.az:8305/author" />
        <meta
          property="og:image"
          content={`https://dev.optima.az:8305/${LogoAAA}`}
        />
      </Helmet>
      {/* ====================== END HEADER ====================== */}

      <div className="container py-16 lg:pb-28 lg:pt-20 space-y-16 lg:space-y-28">
        <main>
          {/* TABS FILTER */}
          <div className="flex flex-col sm:items-center sm:justify-between sm:flex-row">
            <Nav className="sm:space-x-2">
              {TABS.map((item, index) => (
                <NavItem
                  key={index}
                  isActive={true}
                >
                  {item}
                </NavItem>
              ))}
            </Nav>
            <div className="block my-4 border-b w-full border-neutral-300 dark:border-neutral-500 sm:hidden"></div>
            {/* <div className="flex justify-end">
              <ArchiveFilterListBox lists={FILTERS} />
            </div> */}
          </div>

          {/* LOOP ITEMS */}

          {!blogsLoading ? (
  <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8 mt-8 lg:mt-10">
    {blogs?.length > 0 ? (
      blogs?.map((blog) => (
        <Card11 key={blog?.id} post={POST_TEMP} blog={blog} />
      ))
    ) : (
      <div className="col-span-full flex justify-center items-center">
        <span className="text-2xl text-center text-gray-500">{t('nothingFound')}</span>
      </div>
    )}
  </div>
) : (
  <div className="flex justify-center pt-10 pb-16 md:py-16 lg:pb-28 lg:pt-20">
    <Loading size="large" />
  </div>
)}


          {/* PAGINATION */}
          <div className="flex flex-col mt-12 lg:mt-16 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row sm:justify-between sm:items-center">
            {/* <Pagination /> */}
            {/* <ButtonPrimary>Show me more</ButtonPrimary> */}
            <PaginationCustom
              totalNumberOfPages={Math.ceil(totalNumberOfBlogs / pageSize)}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        </main>

        {/* === SECTION 5 === */}
        {/* <div className="relative py-16">
          <BackgroundSection />
          <SectionGridCategoryBox
            categories={DEMO_CATEGORIES.filter((_, i) => i < 10)}
          />
          <div className="text-center mx-auto mt-10 md:mt-16">
            <ButtonSecondary>Show me more</ButtonSecondary>
          </div>
        </div> */}

        {/* === SECTION 5 === */}
        {/* <SectionSliderNewAuthors
          heading="Top elite authors"
          subHeading="Discover our elite writers"
          authors={DEMO_AUTHORS.filter((_, i) => i < 10)}
        /> */}

        {/* SUBCRIBES */}
        {/* <SectionSubscribe2 /> */}
      </div>
    </div>
  );
};

export default PageAuthor;
